import Vue from "vue";
import DynamicFieldLookup from './dynamicFieldLookup';

export default Vue.extend({
  data() {
    return {
      selectedDynamicField: null
    }
  },
  mixins: [DynamicFieldLookup],
  methods: {
    dynamicFieldOnClick(e) {
      const $target = $(e.target);
      if (e.target.tagName === 'VAR') {
        this.selectedDynamicField = $target;
        this.setWindowSelection($target[0])
      }
    },
    setWindowSelection(incomingNode: Node) {
      // sets caret after selected dynamic field
      const sel = window.getSelection();
      let range = document.createRange();
      let node: Node = incomingNode || sel.focusNode.parentNode.nextSibling;
      let offset = 0;
      // if selected dynamic field is end of line
      if (!node) {
        node = sel.focusNode.parentNode.parentNode;
        offset = node.childNodes.length;
      }
      range.setStart(node, offset);
      range.setEnd(node, offset);
      sel.removeAllRanges();
      sel.addRange(range);
    },
    dynamicFieldOnKeydown(e) {
      if (e.key === 'Backspace' || e.key === 'Delete') {
        if (this.selectedDynamicField) {
          this.clearSelectedDynamicFields()
          this.selectedDynamicField.remove()
        }
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        if (this.selectedDynamicField) {
          this.setWindowSelection(e.key === 'ArrowRight' ? this.selectedDynamicField.nextSibling : this.selectedDynamicField.previousSibling)
          this.selectedDynamicField = null
        }
        let { focusNode, anchorOffset } = window.getSelection(); // focusNode is some non-dynamic field Node; anchorOffset is the caret's index in said node
        if (focusNode === null) return;
        // determine if caret is about to pass over a dynamic field
        if (focusNode.childNodes.length) {
          let $adjacentEl
          if (focusNode.tagName === 'P') {
            $adjacentEl = e.key === 'ArrowRight' ? $(focusNode.childNodes[anchorOffset + 1]) : $(focusNode.childNodes[anchorOffset - 1])
          } else {
            $adjacentEl = e.key === 'ArrowRight' ? $(focusNode.nextSibling) : $(focusNode.previousSibling)
          }
          if ($adjacentEl) {
            this.selectedDynamicField = $adjacentEl
            this.setWindowSelection($adjacentEl[0])
          }
        } else {
          let $oncomingSibling = e.key === 'ArrowRight' ? $(focusNode.nextSibling) : $(focusNode.previousSibling);
          let $outgoingSibling = e.key === 'ArrowRight' ? $(focusNode.previousSibling) : $(focusNode.nextSibling);
          if (!$oncomingSibling[0]) {
            if (focusNode.parentNode.nodeName !== 'P') { // occurs if focusNode is text node that is bolded, italicized, etc.
              $oncomingSibling = e.key === 'ArrowRight' ? $(focusNode.parentNode.nextSibling) : $(focusNode.parentNode.previousSibling);
            }
          }
          if (!$outgoingSibling[0]) {
            if (focusNode.parentNode.nodeName !== 'P') {
              $outgoingSibling = e.key === 'ArrowRight' ? $(focusNode.parentNode.previousSibling) : $(focusNode.parentNode.nextSibling);
            }
          }
          const atAdjacentChar = e.key === 'ArrowRight' ? anchorOffset === focusNode['length'] : anchorOffset === 0;
          if (atAdjacentChar && $oncomingSibling.hasClass('pill')) {
            this.selectedDynamicField = $oncomingSibling
            this.setWindowSelection($oncomingSibling[0])
          }
        }
      }
    },
    clearSelectedDynamicFields() {
      $('div.fr-element.fr-view').find('var').each((varIndex, varTag) => {
        $(varTag).removeClass('active');
      })
    },
  },
  watch: {
    selectedDynamicField($newVal, $oldVal) {
      // remove all 'active' classes if oldVal exists, add to newVal if newVal exists; otherwise toggle on newVal
      if ($newVal) {
        if ($oldVal && $oldVal[0] !== $newVal[0]) {
          this.clearSelectedDynamicFields();
          $($newVal).addClass('active');
        } else if ($oldVal && $newVal[0] === $oldVal[0]) {
          this.selectedDynamicField = null
          $newVal.removeClass('active')
        } else {
          $newVal.toggleClass('active');
        }
      } else if ($oldVal) {
        this.clearSelectedDynamicFields();
      }
    }
  }
})